<div class="bg-light-primary rounded p-y-30 p-x-24 m-b-30 overflow-hidden" *ngIf="perfil === perfilEnum.ADMINISTRADOR">
  <div class="row">
    <div class="col-sm-8">
      <h4 class="page-title m-0 f-s-20 f-w-600 m-b-16">
        {{ pageInfo?.['title'] }}
      </h4>
      <div class="d-flex align-items-center overflow-hidden">
        <div class="flex item-start justify-center gap-8">
          <span
          *ngFor="let url of pageInfo?.['urls'];index as i; last as isLast"
          class="breadcrumb-item"
          [ngClass]="{active: isLast}"
          [routerLink]="url.url"
          >
          <a [routerLink]="url.url" class="mr-2">{{ url.title }}</a>
          <i-tabler *ngIf="!isLast" name="circle-filled" class="icon-8"></i-tabler>
          </span>
        </div>
        
      </div>
    </div>
  </div>
</div>
